import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import SeoHead from '@/components/feature/SeoHead';

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <SeoHead
        title="页面不存在 - 爆料直播网"
        description="你访问的页面不存在或已被移除，可以回到首页查看今日直播排期与即将开始场次。"
        keywords="爆料直播,页面不存在,今日直播排期"
        path={location.pathname}
      />
      <section className="w-full bg-background-50">
        <div className="container-page flex min-h-[62vh] flex-col items-center justify-center py-20 text-center">
          <span className="font-heading text-[80px] font-bold leading-none text-background-300 md:text-[120px]">
            404
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这个页面还没有内容
          </h1>
          <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
            你访问的地址是
            <span className="mx-1 rounded bg-background-100 px-1.5 py-0.5 font-mono text-xs text-foreground-700">
              {location.pathname}
            </span>
            ，它可能已被移除或链接有误。回到首页可以查看今日直播排期与即将开始的场次。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-home-4-line" aria-hidden="true" />
              </span>
              返回首页
            </Link>
            <Link
              to="/schedule"
              className="flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-schedule-line" aria-hidden="true" />
              </span>
              查看今日排期
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}